<template>
  <div>
    <button id="FloatingButton" @click="FloatingButtonAction">
      <p>
        <v-icon :title="naslov">close</v-icon>
      </p>
    </button><!-- /#FloatingButton -->
    <div
        id='Dialog__Overlay--FloatingBtn'
        class="Dialog__Overlay v-overlay "
        style="z-index: 201;"
    >
    </div>
    <div
        id='Dialog__Content--FloatingBtn'
        tabindex="-1"
        data-v-fae5bece=""
        class="Dialog__Content v-dialog__content "
    >
      <div
          id="Dialog"
          class="Dialog v-dialog v-dialog--active" v-bind:class="[this.akcija === '4' || this.akcija === '2' ? 'siri_modal_1200' : this.akcija === '5' || this.akcija === '4' ? 'siri_modal_1400' : 'siri_modal']"
      >
        <div
            data-v-fae5bece=""
            class="v-card"
        >
          <div
              data-v-fae5bece=""
              class="v-card__title headline lighten-2 v-card__title--primary"
          >
            <!-- Modal Titles  -->

            <div v-if="this.akcija === '1'">
              Nova prostorija
            </div>
            <div v-else-if="this.akcija === '2'">
              {{ $t("tank.new_tank") }} / {{ this.naziv_prostorije }}
            </div>
            <div v-else-if="this.akcija === '3'">
              Novi tip magacina
            </div>
            <div v-else-if="this.akcija === '4'">
              Novi magacin / {{ this.naziv_prostorije }}
            </div>
            <div v-else-if="this.akcija === '5'">
              {{ this.vinogradGl }}
            </div>
            <div v-else>
              Maka
            </div>

            <button
                id='closeModalBtn'
                @click='FloatingButtonAction'
                class="v-btn v-btn--flat white"
            >
              <v-icon>close</v-icon>
            </button>
          </div>

          <div
              data-v-fae5bece=""
              class="spacer"
          >
          </div>


          <div v-if="this.akcija === '1'">
            <Room @mounted="customMounted"/>
          </div>
          <div v-else-if="this.akcija === '2'">
            <Tank @mounted="customMounted"/>
          </div>
          <div v-else-if="this.akcija === '3'">
            <WareHouseType @mounted="customMounted"/>
          </div>
          <div v-else-if="this.akcija === '4'">
            <WareHouse @mounted="customMounted"/>
          </div>
          <div v-else-if="this.akcija === '5'">
            <VineYard @mounted="customMounted"/>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
	import {serverBus} from "../../main";

	import Room from "./../Room";
	import Tank from "./../Tank";
	import WareHouseType from "./../WareHouseTypePom";
	import WareHouse from "./../WareHousePom";
	import VineYard from "./../VineYardPom";
import { daLiJeVinarija } from "../../helpers/Functions";

	const MountedMixin = {
		mounted() {
			// alert(222222);
			this.$emit("mounted");
		}
	};

	export default {
		name: "FloatingButton",
		dialog: false,
		data() {
			return {
				akcija: '1',
        tank_phase_vineId: 0,
        idRoom: 0,
        naziv_prostorije: "",
        makaClass: "dodavanje_merenje",
        naslov: "",
    vinarija: true,
      vinogradGl: "Novi vinograd",
			};
		},
		components: {
			Room: resolve => {
				setTimeout(() => {
					const component = Room;
					component.mixins = [];
					component.mixins.push(MountedMixin);
					resolve(component);
					// This could be the result of System.import of an async require
				}, 300);
			},
			Tank: resolve => {
				setTimeout(() => {
					const component = Tank;
					component.mixins = [];
					component.mixins.push(MountedMixin);
					resolve(component);
					// This could be the result of System.import of an async require
				}, 300);
			},
			WareHouseType: resolve => {
				setTimeout(() => {
					const component = WareHouseType;
					component.mixins = [];
					component.mixins.push(MountedMixin);
					resolve(component);
					// This could be the result of System.import of an async require
				}, 300);
			},
			WareHouse: resolve => {
				setTimeout(() => {
					const component = WareHouse;
					component.mixins = [];
					component.mixins.push(MountedMixin);
					resolve(component);
					// This could be the result of System.import of an async require
				}, 300);
			},
			VineYard: resolve => {
				setTimeout(() => {
					const component = VineYard;
					component.mixins = [];
					component.mixins.push(MountedMixin);
					resolve(component);
					// This could be the result of System.import of an async require
				}, 300);
			}
		},
		methods: {
			// FloatingButtonAction(e) {
			//   alert(this.akcija);

			// 	// // console.log(e);
			// 	alert('hi');
			// },
			FloatingButtonAction(e) {

        const Dialog__Content = document.getElementById("Dialog__Content--FloatingBtn"),
					Dialog__Overlay = document.getElementById("Dialog__Overlay--FloatingBtn");

				let vueInstance = this;
				let isOpen = false;

// // alert(123456);
// alert(this.idRoom);
// alert(this.$parent.idRoom);

let idRoomPom = this.$parent.idRoom;
let idWareHouseTypePom = this.$parent.idWareHouseType;

let akcijaPom = Number(this.akcija);

this.naziv_prostorije = this.$parent.nazivProstorije;

				function modalOpen() {
          

					if (!isOpen) {
						//// // console.log(e.target);
						if (e.target !== undefined) {
							vueInstance.$data.actionId = e.target.dataset.actionId;
						}

						Dialog__Content.style.display = "flex";
						Dialog__Content.classList += " v-dialog__content--active";
						Dialog__Overlay.style.display = "block";
						Dialog__Overlay.classList += " v-overlay--active";

        if (akcijaPom === 1) {
          serverBus.$emit("room_item");
          serverBus.$emit("room");
				}
				else if (akcijaPom === 2) {
          serverBus.$emit("tank", idRoomPom);
          serverBus.$emit("tank_item", idRoomPom);
        }
				else if (akcijaPom === 4) {
          serverBus.$emit("warehouse_item", idWareHouseTypePom);
        }
        
            isOpen = true;
            
					}
				}

				function modalClose() {
					// serverBus.$off("room");
					// serverBus.$off("tank");
					// serverBus.$off("tank_item");

					Dialog__Content.style.display = "none";
					Dialog__Content.classList.remove("v-dialog__content--active");
					Dialog__Overlay.style.display = "none";
					Dialog__Overlay.classList.remove("v-overlay--active");

					isOpen = false;

					// alert("maka");
					serverBus.$emit("osvezi_meni");
					serverBus.$emit("ucitaj_podatke");
				}

				if (e.target !== undefined) {
					if (e.target.nodeName !== "UL" && e.target.nodeName !== "DIV") {

					}

					/**
					 * Close Modal
					 */
					if (e.target.id === "closeModalBtn") {
						modalClose();
					}
					else {
						/**
						 * Open Modal
						 */
						modalOpen();
					}

				} else {
					alert(e);
				}

			},
			customMounted() {


			}
		},
		mounted() {
      serverBus.$off("room");
      // serverBus.$off("room_item");
			serverBus.$off("tank");
			serverBus.$off("tank_item");
			serverBus.$off("warehouse_item");
			serverBus.$off("warehouse");
      serverBus.$off("refresh_vine_yard");

      this.akcija = this.$parent.floating_akcija;
      
      if (this.akcija === "1")
        serverBus.$on('fb', (idRoom) => {
          this.idRoom = idRoom;
        });

        if (this.akcija === "1")
          this.naslov = "Nova prostorija";
        else if (this.akcija === "2")
          this.naslov = this.$t("tank.new_tank");
        else if (this.akcija === "3")
          this.naslov = "Novi tip magacina";
        else if (this.akcija === "4")
          this.naslov = "Novi magacin";
        else if (this.akcija === "5")
          this.naslov = this.vinogradGl;
		},
  beforeMount() {
    this.vinarija = daLiJeVinarija(localStorage.getItem("isWinery"));

    if(!this.vinarija)
      this.vinogradGl = "Novi zasad";
  }
	};
</script>
<style scoped lang='scss'>
  // @import "./../parts/../../assets/sass/parts/modalStyles";
@import "./../parts/../../assets/sass/parts/modalStyles_siri_modal";
  /*#Dialog {*/
  /*max-width: 700px;*/
  /*&__Overlay {*/
  /*display: none;*/
  /*z-index: 201;*/
  /*}*/
  /*&__Content {*/
  /*display: none;*/
  /*z-index: 202;*/
  /*.v-card__title {*/
  /*padding-left: 30px;*/
  /*padding-bottom: 0;*/
  /*}*/
  /*.container {*/
  /*padding-top: 0;*/
  /*}*/
  /*}*/
  /*}*/

  /*.v-card__title {*/
  /*padding-top: 15px;*/
  /*justify-content: space-between;*/
  /*}*/

  /*#closeModalBtn {*/
  /*width: 70px;*/
  /*&:before {*/
  /*background-color: transparent;*/
  /*}*/
  /*}*/

  #FloatingButton {
    position: fixed;
    right: 10px;
    bottom: 20px;
    width: 54px;
    height: 54px;
    font-size: 40px;
    border-radius: 50%;
    color: #ffffff;
    background-color: #018389;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
    transition: .2s ease-in-out;
    @media (max-width: 1200px) {
    height: 71px;
    padding-top: 10px;
    padding-right: 55px;
  }
    p {
      position: relative;
      width: 100%;
      height: 100%;
      i {
        position: absolute;
        left: 15px;
        top: 15px;
        transform: rotate(45deg);
        color: #ffffff;
      }
    }
    &:active, &:focus {
      box-shadow: none;
    }
  }
</style>